/**
 * StatCard — 대시보드 지표 표시 카드
 *
 * 아이콘(선택), 레이블, 값, 변화량(선택)을 세로로 쌓아 보여준다.
 * change 문자열이 '+' 로 시작하면 녹색, '-' 로 시작하면 빨간색을 적용한다.
 */

import { ReactNode } from 'react'
import { cn } from '../../lib/cn.js'
import styles from './StatCard.module.css'

interface StatCardProps {
  /** 지표 레이블 텍스트 */
  label: string
  /** 지표 값 (숫자 또는 문자열) */
  value: string | number
  /** 변화량 표시 텍스트 (예: '+12%', '-3') */
  change?: string
  /** 좌측 아이콘 노드 */
  icon?: ReactNode
  className?: string
}

/** change 문자열 첫 글자로 색상 클래스 결정 */
function resolveChangeClass(change: string): string {
  if (change.startsWith('+')) return styles.changePositive
  if (change.startsWith('-')) return styles.changeNegative
  return styles.changeNeutral
}

export function StatCard({ label, value, change, icon, className }: StatCardProps) {
  return (
    <div className={cn(styles.root, className)}>
      {icon && <div className={styles.iconWrap}>{icon}</div>}
      <div className={styles.content}>
        <p className={styles.label}>{label}</p>
        <p className={styles.value}>{value}</p>
        {change && (
          <p className={cn(styles.change, resolveChangeClass(change))}>{change}</p>
        )}
      </div>
    </div>
  )
}
